export type AppType = 'education' | 'trade';

const APP_TYPE_STORAGE_KEY = 'appType';

export const getAppType = (): AppType => {
  const stored = localStorage.getItem(APP_TYPE_STORAGE_KEY);
  return (stored as AppType) || 'education'; // Default to education
};

export const setAppType = (appType: AppType): void => {
  localStorage.setItem(APP_TYPE_STORAGE_KEY, appType);
};

export const APP_TYPE_LABELS: Record<AppType, string> = {
  education: 'Fesilah Education',
  trade: 'Fesilah Trade',
};

